import { type FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Button, Container } from '@/shared/ui';
import { Link } from '@tanstack/react-router';

export const NotFoundView: FC = () => {
  const { t } = useTranslation();

  return (
    <Container className="flex min-h-dvh flex-col items-center justify-center gap-4">
      <h1 className="text-3xl font-semibold text-foreground">
        {t('pages.notFound.title')}
      </h1>
      <p className="text-muted-foreground">{t('pages.notFound.description')}</p>
      <Button asChild>
        <Link to="/dashboard">{t('pages.notFound.backHome')}</Link>
      </Button>
    </Container>
  );
};

NotFoundView.displayName = 'NotFoundView';
